// ViewHeader.js - Cabeçalho comum a todas as vistas de aparelho
//
// As dez vistas repetiam byte a byte o mesmo bloco: botão de voltar, ícone,
// título, subtítulo e botão de atualizar. Quando a barra de idiomas entrou
// no menu, foi preciso lembrar-me de dez sítios; agora é um.
//
// O botão de atualizar é opcional: a vista da TV, por exemplo, tem o seu
// próprio ritmo de leitura e não o mostra.
import React from 'react';
import { ArrowLeft, RefreshCw } from 'lucide-react';

function ViewHeader({ icon, iconClass, titulo, subtitulo, onBack, onRefresh, loading }) {
  const Icon = icon;
  return (
    <div className="view-header">
      <button onClick={onBack} className="btn-back">
        <ArrowLeft size={24} />
      </button>
      <div className="view-header-content">
        <div className="view-header-title">
          <Icon size={32} className={iconClass} />
          <h1>{titulo}</h1>
        </div>
        {subtitulo && <span className="view-subtitle">{subtitulo}</span>}
      </div>
      {onRefresh && (
        <button onClick={onRefresh} className="btn-refresh" disabled={loading}>
          <RefreshCw size={20} className={loading ? 'spinning' : ''} />
        </button>
      )}
    </div>
  );
}

export default ViewHeader;
